module.exports = __webpack_public_path__ + "img/rotten-tomato-60-89.a077eafe.png";